'use client';

import { type ReactNode, useLayoutEffect, useRef } from 'react';

import { searchHeader } from '@/src/layouts/persistentSearchLayout.styles';

type SearchHeaderProps = {
  children: ReactNode;
};

export function SearchHeader({ children }: SearchHeaderProps) {
  const headerRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const header = headerRef.current;
    const frame = header?.parentElement;
    if (!header || !frame) return;

    const syncHeaderHeight = () => {
      frame.style.setProperty('--search-header-height', `${header.offsetHeight}px`);
    };

    syncHeaderHeight();

    const observer = new ResizeObserver(syncHeaderHeight);
    observer.observe(header);

    return () => {
      observer.disconnect();
      frame.style.removeProperty('--search-header-height');
    };
  }, []);

  return (
    <div ref={headerRef} className={searchHeader} data-srp-component="search-header">
      {children}
    </div>
  );
}
